import React from 'react';
import { classNames } from '../../../utils/classNames';
import './Fliter.css'

export function FliterForm(props: {
    children: JSX.Element | JSX.Element[] | string
}) {
    return (
        <div className="float-left form-inline">
            {props.children}
        </div>
    )

}

export function FliterButton(props: {
    children: JSX.Element | JSX.Element[] | string
}) {
    return (
        <div className="float-right">
            {props.children}
        </div>
    )
}

export default function Fliter(props: {
    className?: string,
    children: JSX.Element | JSX.Element[] | string
}) {
    return (
        <div className={classNames("fliter", props.className)} >
            {props.children}
        </div>
    )
}